import React from 'react';
import PropTypes from 'prop-types';
import { styled, Typography, Backdrop } from '@nextiva/next-ui-components';
import { DotProgress } from 'components/DotProgress';
import colors from 'styles/application/_base/_variables.scss';

const StyledBackDrop = styled(Backdrop)`
  background-color: ${colors.backdropColor};
  flex-direction: column;
`;

const StyledTypography = styled(Typography)`
  font-size: 1.125rem;
  margin: 24px;
  letter-spacing: 0.15px;
  text-shadow: 0px 0px 8px ${({ theme }) => theme.palette.primary.contrastText};
`;

export const FullScreenBackdrop = ({ message = '', open = false }) => {
  return (
    <StyledBackDrop open={open}>
      {open && (
        <>
          <DotProgress />
          {Boolean(message) && (
            <StyledTypography variant="body1"> {message}</StyledTypography>
          )}
        </>
      )}
    </StyledBackDrop>
  );
};

FullScreenBackdrop.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
};
